import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
import MyProfile from "./MyProfile";

export const AccountPagesConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/my-profile",
        element: <MyProfile />,
    },
];
